import { render, staticRenderFns } from "./DichiarazioneTurno.vue?vue&type=template&id=760e1471&"
import script from "./DichiarazioneTurno.vue?vue&type=script&lang=js&"
export * from "./DichiarazioneTurno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports